import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const manufacturerRouter: Array<RouteConfig> = [
  {
    path: "manufacturers_list",
    name: "manufacturers_list",
    component: () => import("@/views/Manufacturer/ManufacturerList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "manufacturers_list/:id",
    name: "manufacturerId",
    component: () => import("@/views/Manufacturer/Manufacturer.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "manufacturers_list/create_manufacturer",
    name: "new_manufacturer",
    component: () => import("@/views/Manufacturer/NewManufacturer.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  }
];

export default manufacturerRouter;
